import * as React from 'react';

export const ArrowUpIcon: React.FunctionComponent<{
  color: string;
  ariaName?: string;
}> = ({ color, ariaName }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        d="M17.0459 14.8033C17.2412 14.9986 17.5578 14.9986 17.753 14.8033C17.9483 14.608 17.9483 14.2915 17.753 14.0962L12.8033 9.14645C12.608 8.95118 12.2915 8.95118 12.0962 9.14645L7.14645 14.0962C6.95118 14.2915 6.95118 14.608 7.14645 14.8033C7.34171 14.9986 7.65829 14.9986 7.85355 14.8033L12.4497 10.2071L17.0459 14.8033Z"
        fill={color}
      />
    </svg>
  );
};
